var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"daojishi"},[(_vm.guoqi)?_c('div',{staticStyle:{"color":"#333"}},[_vm._v("报告已过期24小时内可查看")]):_c('div',{staticClass:"pointer",staticStyle:{"color":"green"},on:{"click":_vm.onchick}},[_vm._v("查询成功(请于"+_vm._s(_vm.hours)+":"+_vm._s(_vm.minutes)+":"+_vm._s(_vm.seconds)+"内点击查看报告)")])])
}
var staticRenderFns = []

export { render, staticRenderFns }